import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { UnstyledButton } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FormInput } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { NIHSS_MAX_SCORE } from "./field-constants";
/** Manual NIHSS total-score entry (0–42) in an expandable block. */
export function NihssScoreField(_ref) {
  var _field$observation, _field$footer;
  var field = _ref.field,
    value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(Boolean(value)),
    open = _useState[0],
    setOpen = _useState[1];
  var current = String(value !== null && value !== void 0 ? value : "");
  var toggle = function toggle() {
    trackEvent(ANALYTICS_EVENTS.NIHSS_SCORE_TOGGLE, {
      fieldId: field.id
    });
    if (open) onChange("");
    setOpen(!open);
  };
  var change = function change(raw) {
    var numeric = Number(raw);
    if (raw !== "" && (numeric < 0 || numeric > NIHSS_MAX_SCORE)) return;
    onChange(raw);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "rounded-sds-200 border border-sds-base-default"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-4 py-3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-base text-sds-base-default"
  }, t((_field$observation = field.observation) !== null && _field$observation !== void 0 ? _field$observation : "manually_enter_score", {
    defaultValue: "Manually enter score"
  })), /*#__PURE__*/React.createElement(UnstyledButton, {
    type: "button",
    disabled: disabled,
    "data-testid": "nihss-score-toggle-".concat(field.id),
    onClick: toggle,
    className: "text-style-body-small-strong text-teal-400 dark:text-teal-300"
  }, open ? t("close", {
    defaultValue: "Close"
  }) : t("enter_score", {
    defaultValue: "Enter score"
  }))), open ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center gap-2 px-4 pb-4"
  }, /*#__PURE__*/React.createElement(FormInput, {
    type: "number",
    inputMode: "numeric",
    className: "w-24",
    value: current,
    disabled: disabled,
    onChange: function onChange(event) {
      return change(event.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.NIHSS_SCORE, {
        fieldId: field.id
      });
    },
    "data-testid": "nihss-score-".concat(field.id)
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-center text-style-label-base text-sds-base-tertiary"
  }, (_field$footer = field.footer) !== null && _field$footer !== void 0 && _field$footer.length ? field.footer.map(function (line) {
    return /*#__PURE__*/React.createElement("div", {
      key: line
    }, t(line));
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, t("nihss_very_severe", {
    defaultValue: "Very severe: >25"
  })), /*#__PURE__*/React.createElement("div", null, t("nihss_severe", {
    defaultValue: "Severe: 15–24"
  })), /*#__PURE__*/React.createElement("div", null, t("nihss_moderate", {
    defaultValue: "Moderate: 5–14"
  })), /*#__PURE__*/React.createElement("div", null, t("nihss_mild", {
    defaultValue: "Mild: 1–5"
  }))))) : null);
}